import { ICommitDeliveryInput } from 'generated/graphql-gateway';
import { IUseCartTip } from 'state/order/hooks/use-cart-tip';
import { IPlaceAddress } from 'utils/geolocation';

interface IBuildCommitDeliveryInput {
  deliveryAddress: IPlaceAddress | null;
  deliveryInstructions?: string;
  phoneNumber: string;
  isDelivery: boolean;
  tipAmount: IUseCartTip['tipAmount'];
}

export const buildCommitDeliveryInput = ({
  deliveryAddress,
  deliveryInstructions,
  phoneNumber,
  isDelivery,
  tipAmount,
}: IBuildCommitDeliveryInput): ICommitDeliveryInput | null => {
  if (!isDelivery || !deliveryAddress) {
    return null;
  }

  const alias = deliveryAddress.alias;
  const defaultInstruction = deliveryAddress.defaultInstruction;

  return {
    instructions: deliveryInstructions,
    tipCents: tipAmount,
    pushNotification: true,
    dropoff: {
      ...deliveryAddress,
      alias,
      defaultInstruction,
      shouldSave: deliveryAddress.shouldSave ?? false,
      phoneNumber,
    },
  };
};
